/**
 * This is an intentionally very permissive email validation function whose purpose is to help avoid typographical
 * errors. Full email validation is very complex and should only be trusted by actually attempting to email the address.
 */
export default function validateEmail(email: string): string[] {
  const emailTrimmed = email.trim();
  if (emailTrimmed === "") {
    return [];
  }

  const match = emailTrimmed.match(/^([^@ ]+)@([^@ ]+)$/g);
  if (match === null) {
    return ["Email is not a valid email address"];
  }

  return [];
}
